module.exports = __webpack_public_path__ + "img/13.eb384e45.jpg";